import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaticDataService {

  constructor(private httpClient: HttpClient) { }

  produtos(request: any) {
    return this.httpClient.get<any>(
      `../../../assets/data/produtos.json`,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      }
    );
  }

  categorias() {
    return this.httpClient.get<any>(
      `../../../assets/data/categorias.json`,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      }
    );
  }

  bancos() {
    return this.httpClient.get<any>(
      `../../../assets/data/bancos.json`,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      }
    );
  }

  produto(request: any) {
    return this.httpClient.get<any>(
      `../../../assets/data/produto-${request}.json`,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        })
      }
    );
  }
}
